export const pokemonEmojis = [
  { id: 1, emojis: '🌱🐸🌿' }, // Bulbasaur
  { id: 2, emojis: '🌱🦎🌿' }, // Ivysaur
  { id: 3, emojis: '🌱🐢🌿' }, // Venusaur
  { id: 4, emojis: '🔥🦎👶' }, // Charmander
  { id: 5, emojis: '🔥🦎🌋' }, // Charmeleon
  { id: 6, emojis: '🔥🐲🌋' }, // Charizard
  { id: 7, emojis: '🐢💦💧' }, // Squirtle
  { id: 8, emojis: '🐢💦💧' }, // Wartortle
  { id: 9, emojis: '🐢🔫🌊' }, // Blastoise
  { id: 10, emojis: '🐛🍃🌿' }, // Caterpie
  { id: 11, emojis: '🐛🛡️🌿' }, // Metapod
  { id: 12, emojis: '🦋🌸🌼' }, // Butterfree
  { id: 13, emojis: '🐛🌿🐝' }, // Weedle
  { id: 14, emojis: '🐛🛡️🐝' }, // Kakuna
  { id: 15, emojis: '🐝🗡️🔪' }, // Beedrill
  { id: 16, emojis: '🐣🐤🌿' }, // Pidgey
  { id: 17, emojis: '🐦🐥🌿' }, // Pidgeotto
  { id: 18, emojis: '🐦✈️🦅' }, // Pidgeot
  { id: 19, emojis: '🐀🧀🐭' }, // Rattata
  { id: 20, emojis: '🐀🧀🐭' }, // Raticate
  { id: 21, emojis: '🐤🐦🔪' }, // Spearow
  { id: 22, emojis: '🐦🦅🍁' }, // Fearow
  { id: 23, emojis: '🐍🟣☣️' }, // Ekans
  { id: 24, emojis: '🐍🟣☣️' }, // Arbok
  { id: 25, emojis: '🐁⚡🐭' }, // Pikachu
  { id: 26, emojis: '⚡🐹🐭' }, // Raichu
  { id: 27, emojis: '🐭🌵🔪' }, // Sandshrew
  { id: 28, emojis: '🦔🏜️🔪' }, // Sandslash
  { id: 29, emojis: '🦔☣️🌸' }, // Nidoran♀️
  { id: 30, emojis: '🦔☣️🌼' }, // Nidorina
  { id: 31, emojis: '🦔☣️👑' }, // Nidoqueen
  { id: 32, emojis: '🦔☣️🌸' }, // Nidoran♂️
  { id: 33, emojis: '🦔☣️🌼' }, // Nidorino
  { id: 34, emojis: '🦔☣️👑' }, // Nidoking
  { id: 35, emojis: '🧚💗🌙' }, // Clefairy
  { id: 36, emojis: '🧚🌷🌸' }, // Clefable
  { id: 37, emojis: '🔥🦊🐾' }, // Vulpix
  { id: 38, emojis: '🔥🦊🐾' }, // Ninetales
  { id: 39, emojis: '🎵🎤😴' }, // Jigglypuff
  { id: 40, emojis: '🎵😴⭐' }, // Wigglytuff
  { id: 41, emojis: '🦇⚫🌑' }, // Zubat
  { id: 42, emojis: '🦇⚫🌑' }, // Golbat
  { id: 43, emojis: '🌿🌺👶' }, // Oddish
  { id: 44, emojis: '🌿🤢🌺' }, // Gloom
  { id: 45, emojis: '🌿🌺🌸' }, // Vileplume
  { id: 46, emojis: '🍄🦀🍄' }, // Paras
  { id: 47, emojis: '🍄🦀🌑' }, // Parasect
  { id: 48, emojis: '🐛⚫🦇' }, // Venonat
  { id: 49, emojis: '🦋⚫🦇' }, // Venomoth
  { id: 50, emojis: '🕳️🦔👶' }, // Diglett
  { id: 51, emojis: '🕳️🕳️🕳️' }, // Dugtrio
  { id: 52, emojis: '🐱💰😻' }, // Meowth
  { id: 53, emojis: '🐱💰🐈' }, // Persian
  { id: 54, emojis: '🦆💦🧠' }, // Psyduck
  { id: 55, emojis: '🦆💦🧠' }, // Golduck
  { id: 56, emojis: '🐵👊🐒' }, // Mankey
  { id: 57, emojis: '🐵👊🐒' }, // Primeape
  { id: 58, emojis: '🐕🔥🐾' }, // Growlithe
  { id: 59, emojis: '🐕🔥🐾' }, // Arcanine
  { id: 60, emojis: '💦🐸🔵' }, // Poliwag
  { id: 61, emojis: '💦🥋🐸' }, // Poliwhirl
  { id: 62, emojis: '💦🥋🐸' }, // Poliwrath
  { id: 63, emojis: '🧠👶🥄' }, // Abra
  { id: 64, emojis: '🧠✨🥄' }, // Kadabra
  { id: 65, emojis: '🥄🧠✨' }, // Alakazam
  { id: 66, emojis: '💪👊💪' }, // Machop
  { id: 67, emojis: '💪🥋💪' }, // Machoke
  { id: 68, emojis: '💪🥋💪' }, // Machamp
  { id: 69, emojis: '🌿🔔🌿' }, // Bellsprout
  { id: 70, emojis: '🌿🔔😮' }, // Weepinbell
  { id: 71, emojis: '🌿🔔☢️' }, // Victreebel
  { id: 72, emojis: '🐙💦🌊' }, // Tentacool
  { id: 73, emojis: '🐙💦🌊' }, // Tentacruel
  { id: 74, emojis: '🗻💪⛰️' }, // Geodude
  { id: 75, emojis: '🗻💪⛰️' }, // Graveler
  { id: 76, emojis: '🗻💪⛰️' }, // Golem
  { id: 77, emojis: '🐴🔥🐾' }, // Ponyta
  { id: 78, emojis: '🐴🔥🐾' }, // Rapidash
  { id: 79, emojis: '😴🌊💤' }, // Slowpoke
  { id: 80, emojis: '😴🌊💤' }, // Slowbro
  { id: 81, emojis: '🧲🔋🔘' }, // Magnemite
  { id: 82, emojis: '🧲🔋👪' }, // Magneton
  { id: 83, emojis: '🦆✂️🍴' }, // Farfetch'd
  { id: 84, emojis: '🐦🐦🏃' }, // Doduo
  { id: 85, emojis: '🐦🐦🐦' }, // Dodrio
  { id: 86, emojis: '🌊👶❄️' }, // Seel
  { id: 87, emojis: '🌊❄️🏝️' }, // Dewgong
  { id: 88, emojis: '🤢🏭☣️' }, // Grimer
  { id: 89, emojis: '🤢🏭☣️' }, // Muk
  { id: 90, emojis: '🐚💦👅' }, // Shellder
  { id: 91, emojis: '🐚😈💦' }, // Cloyster
  { id: 92, emojis: '👻😱🟣' }, // Gastly
  { id: 93, emojis: '👻😱👅' }, // Haunter
  { id: 94, emojis: '👻😱👅' }, // Gengar
  { id: 95, emojis: '🐍🔘🗻' }, // Onix
  { id: 96, emojis: '😴🐽🛌' }, // Drowzee
  { id: 97, emojis: '😴🐽👁️' }, // Hypno
  { id: 98, emojis: '🦀🔪🌊' }, // Krabby
  { id: 99, emojis: '🦀🔱👑' }, // Kingler
  { id: 100, emojis: '⚪⚡🔴' }, // Voltorb
  { id: 101, emojis: '⚪⚡🔴' }, // Electrode
  { id: 102, emojis: '🥚🌿👪' }, // Exeggcute
  { id: 103, emojis: '🥚🌴👪' }, // Exeggutor
  { id: 104, emojis: '💀🦴☠️' }, // Cubone
  { id: 105, emojis: '💀☠️🦴' }, // Marowak
  { id: 106, emojis: '🦵🥋💪' }, // Hitmonlee
  { id: 107, emojis: '✊🥊👊' }, // Hitmonchan
  { id: 108, emojis: '😛👅😝' }, // Lickitung
  { id: 109, emojis: '🤢💨🟣' }, // Koffing
  { id: 110, emojis: '🤢🏭🟣' }, // Weezing
  { id: 111, emojis: '🦏🗿🦏' }, // Rhyhorn
  { id: 112, emojis: '🦏🗿🦏' }, // Rhydon
  { id: 113, emojis: '🐰❤️🐣' }, // Chansey
  { id: 114, emojis: '🍝🌿📚' }, // Tangela
  { id: 115, emojis: '🦘👶👨' }, // Kangaskhan
  { id: 116, emojis: '🐉💦👶' }, // Horsea
  { id: 117, emojis: '🐛👑💦' }, // Seadra
  { id: 118, emojis: '🐠💦🐟' }, // Goldeen
  { id: 119, emojis: '🐠💦👑' }, // Seaking
  { id: 120, emojis: '🌟🔴💦' }, // Staryu
  { id: 121, emojis: '🔴🌟🧠' }, // Starmie
  { id: 122, emojis: '🎭🕴️🌐' }, // Mr. Mime
  { id: 123, emojis: '✂️🦗🔪' }, // Scyther
  { id: 124, emojis: '👄💄❄️' }, // Jynx
  { id: 125, emojis: '⚡👊🌩️' }, // Electabuzz
  { id: 126, emojis: '🔥👺🔴' }, // Magmar
  { id: 127, emojis: '👺🦗👿' }, // Pinsir
  { id: 128, emojis: '🐂🌾💨' }, // Tauros
  { id: 129, emojis: '🐠🎣🌊' }, // Magikarp
  { id: 130, emojis: '🐉🌊🔵' }, // Gyarados
  { id: 131, emojis: '🦕🌊🐢' }, // Lapras
  { id: 132, emojis: '🔄🧬🟣' }, // Ditto
  { id: 133, emojis: '🦊🌈🐾' }, // Eevee
  { id: 134, emojis: '🦊💦🌊' }, // Vaporeon
  { id: 135, emojis: '🦊⚡🐾' }, // Jolteon
  { id: 136, emojis: '🦊🔥🐾' }, // Flareon
  { id: 137, emojis: '🤖🐾🧩' }, // Porygon
  { id: 138, emojis: '🐚👀🌊' }, // Omanyte
  { id: 139, emojis: '🐚👹🌊' }, // Omastar
  { id: 140, emojis: '🦀🐚👁️' }, // Kabuto
  { id: 141, emojis: '🔪🦖🌊' }, // Kabutops
  { id: 142, emojis: '🦅🦖⛰️' }, // Aerodactyl
  { id: 143, emojis: '💤🧸😪' }, // Snorlax
  { id: 144, emojis: '❄️🦅🧊' }, // Articuno
  { id: 145, emojis: '⚡🦅🌩️' }, // Zapdos
  { id: 146, emojis: '🔥🦅🌋' }, // Moltres
  { id: 147, emojis: '🐍👶🐉' }, // Dratini
  { id: 148, emojis: '🐲🐍🔮' }, // Dragonair
  { id: 149, emojis: '🐉👋✨' }, // Dragonite
  { id: 150, emojis: '🧬🧪🤯' }, // Mewtwo
  { id: 151, emojis: '✨🔄🌌' }, // Mew
  { id: 152, emojis: '🌱👶🌿' }, // Chikorita
  { id: 153, emojis: '🌱🦌🌿' }, // Bayleef
  { id: 154, emojis: '🌿🦕🌸' }, // Meganium
  { id: 155, emojis: '🔥🦔👶' }, // Cyndaquil
  { id: 156, emojis: '🔥🦔🔥' }, // Quilava
  { id: 157, emojis: '🔥🐻🌋' }, // Typhlosion
  { id: 158, emojis: '💧🐊👶' }, // Totodile
  { id: 159, emojis: '💧🐊🌊' }, // Croconaw
  { id: 160, emojis: '💧🐊🔱' }, // Feraligatr
  { id: 161, emojis: '🐭👀🌿' }, // Sentret
  { id: 162, emojis: '🐭🐇🏃' }, // Furret
  { id: 163, emojis: '🦉🌙👀' }, // Hoothoot
  { id: 164, emojis: '🦉🌙🌟' }, // Noctowl
  { id: 165, emojis: '🐞❤️🐞' }, // Ledyba
  { id: 166, emojis: '🐞✨🦋' }, // Ledian
  { id: 167, emojis: '🕷️👶🕸️' }, // Spinarak
  { id: 168, emojis: '🕷️🕸️🌳' }, // Ariados
  { id: 169, emojis: '🦇🌙👅' }, // Crobat
  { id: 170, emojis: '🐠⚡💡' }, // Chinchou
  { id: 171, emojis: '🐠⚡💡' }, // Lanturn
  { id: 172, emojis: '🐭⚡👶' }, // Pichu
  { id: 173, emojis: '🌙👶🌟' }, // Cleffa
  { id: 174, emojis: '🎵👶🌸' }, // Igglybuff
  { id: 175, emojis: '🥚👶💕' }, // Togepi
  { id: 176, emojis: '🐥🥚🐦' }, // Togetic
  { id: 177, emojis: '🐤🟢🔮' }, // Natu
  { id: 178, emojis: '🐦👁️🔮' }, // Xatu
  { id: 179, emojis: '🐑⚡️👶' }, // Mareep
  { id: 180, emojis: '🐑⚡️✨' }, // Flaaffy
  { id: 181, emojis: '🐏⚡️🌩️' }, // Ampharos
  { id: 182, emojis: '🌸💃🌼' }, // Bellossom
  { id: 183, emojis: '🔵🐰💦' }, // Marill
  { id: 184, emojis: '🔵🐰💦' }, // Azumarill
  { id: 185, emojis: '🌳🙅‍♂️🍃' }, // Sudowoodo
  { id: 186, emojis: '🐸🌧️🎵' }, // Politoed
  { id: 187, emojis: '🌬️🌼🍃' }, // Hoppip
  { id: 188, emojis: '🌬️🌸🍃' }, // Skiploom
  { id: 189, emojis: '🌬️🌼🌿' }, // Jumpluff
  { id: 190, emojis: '🐒👋🌳' }, // Aipom
  { id: 191, emojis: '☀️🌻💧' }, // Sunkern
  { id: 192, emojis: '☀️🌻🌞' }, // Sunflora
  { id: 193, emojis: '🦟✈️🐜' }, // Yanma
  { id: 194, emojis: '🌧️👶💧' }, // Wooper
  { id: 195, emojis: '🌧️🐊🌊' }, // Quagsire
  { id: 196, emojis: '🐈✨🧠' }, // Espeon
  { id: 197, emojis: '🐈🌑🌙' }, // Umbreon
  { id: 198, emojis: '🐦🌑🎩' }, // Murkrow
  { id: 199, emojis: '🐢👑🧠' }, // Slowking
  { id: 200, emojis: '👻💃🌙' }, // Misdreavous
  { id: 201, emojis: '🆎🔡🔠' }, // Unown
  { id: 202, emojis: '😖🔵🛡️' }, // Wobbuffet
  { id: 203, emojis: '🦒🧠🌿' }, // Girafarig
  { id: 204, emojis: '🌲💣🐛' }, // Pineco
  { id: 205, emojis: '🌲🏰🐛' }, // Forretress
  { id: 206, emojis: '🐍🔄🔎' }, // Dunsparce
  { id: 207, emojis: '🦂✈️🌙' }, // Gligar
  { id: 208, emojis: '⛓️🐍⚙️' }, // Steelix
  { id: 209, emojis: '🐶💖🌸' }, // Snubbull
  { id: 210, emojis: '🐶💪💖' }, // Granbull
  { id: 211, emojis: '🐡🎈💦' }, // Qwilfish
  { id: 212, emojis: '✂️🦗🔪' }, // Scizor
  { id: 213, emojis: '🐌🔒🍇' }, // Shuckle
  { id: 214, emojis: '🐞🔨💪' }, // Heracross
  { id: 215, emojis: '🦡❄️🔪' }, // Sneasel
  { id: 216, emojis: '🐻🌙🍯' }, // Teddiursa
  { id: 217, emojis: '🐻💪🌙' }, // Ursaring
  { id: 218, emojis: '🔥🐌🌋' }, // Slugma
  { id: 219, emojis: '🔥🐌🌋' }, // Magcargo
  { id: 220, emojis: '❄️🐖🌨️' }, // Swinub
  { id: 221, emojis: '❄️🐖⛄️' }, // Piloswine
  { id: 222, emojis: '🌊🐚🐠' }, // Corsola
  { id: 223, emojis: '🔫🐟🌊' }, // Remoraid
  { id: 224, emojis: '🐙🔫🌊' }, // Octillery
  { id: 225, emojis: '🎅❄️🎁' }, // Delibird
  { id: 226, emojis: '🌊✈️🔭' }, // Mantine
  { id: 227, emojis: '🦅⚔️🔒' }, // Skarmory
  { id: 228, emojis: '🔥🐶🌑' }, // Houndour
  { id: 229, emojis: '🔥🐶🌑' }, // Houndoom
  { id: 230, emojis: '🐉🌊👑' }, // Kingdra
  { id: 231, emojis: '🐘🌳🍃' }, // Phanpy
  { id: 232, emojis: '🐘⛰️🗻' }, // Donphan
  { id: 233, emojis: '🧠💾👾' }, // Porygon2
  { id: 234, emojis: '🦌🌳💨' }, // Stantler
  { id: 235, emojis: '🎨🐶✏️' }, // Smeargle
  { id: 236, emojis: '👊👶🏋️' }, // Tyrogue
  { id: 237, emojis: '🤸🥊🔝' }, // Hitmontop
  { id: 238, emojis: '❄️👶💋' }, // Smoochum
  { id: 239, emojis: '⚡👶🔌' }, // Elekid
  { id: 240, emojis: '🔥👶🍼' }, // Magby
  { id: 241, emojis: '🐄🥛🍼' }, // Miltank
  { id: 242, emojis: '🐇❤️💝' }, // Blissey
  { id: 243, emojis: '⚡🐯🌩️' }, // Raikou
  { id: 244, emojis: '🔥🦁🌋' }, // Entei
  { id: 245, emojis: '💦🐯💧' }, // Suicune
  { id: 246, emojis: '👶⛰️🗻' }, // Larvitar
  { id: 247, emojis: '🦖⛰️🗻' }, // Pupitar
  { id: 248, emojis: '🦖⛰️🗻' }, // Tyranitar
  { id: 249, emojis: '🦅🌊🌌' }, // Lugia
  { id: 250, emojis: '🐦🔥🌈' }, // Ho-Oh
  { id: 251, emojis: '🥚🌈✨' }, // Celebi
  { id: 252, emojis: '🌿🦎🌳' }, // Treecko
  { id: 253, emojis: '🌿🦎🌳' }, // Grovyle
  { id: 254, emojis: '🐉🌿🌳' }, // Sceptile
  { id: 255, emojis: '🐣🔥👶' }, // Torchic
  { id: 256, emojis: '🐔🔥👊' }, // Combusken
  { id: 257, emojis: '🐔🔥👊' }, // Blaziken
  { id: 258, emojis: '💦🌧️🐸' }, // Mudkip
  { id: 259, emojis: '🌧️🐸🌊' }, // Marshtomp
  { id: 260, emojis: '🌧️🐸🌊' }, // Swampert
  { id: 261, emojis: '🐕🌑🦴' }, // Poochyena
  { id: 262, emojis: '🐺🌑🐾' }, // Mightyena
  { id: 263, emojis: '🦝🌿🐾' }, // Zigzagoon
  { id: 264, emojis: '🦝🌘🐾' }, // Linoone
  { id: 265, emojis: '🐛🕷️🌸' }, // Wurmple
  { id: 266, emojis: '🐛🔒🌸' }, // Silcoon
  { id: 267, emojis: '🦋🌼🌸' }, // Beautifly
  { id: 268, emojis: '🐛🔒🌸' }, // Cascoon
  { id: 269, emojis: '🦋🌼🌑' }, // Dustox
  { id: 270, emojis: '🌧️💦🌱' }, // Lotad
  { id: 271, emojis: '🌧️💦🌱' }, // Lombre
  { id: 272, emojis: '💦🎩🌱' }, // Ludicolo
  { id: 273, emojis: '🌳🌰🌿' }, // Seedot
  { id: 274, emojis: '🌳🌰🍃' }, // Nuzleaf
  { id: 275, emojis: '🌳🌰🌬️' }, // Shiftry
  { id: 276, emojis: '🐦👶🌤️' }, // Taillow
  { id: 277, emojis: '🐦✈️☁️' }, // Swellow
  { id: 278, emojis: '🐦🌊⛅️' }, // Wingull
  { id: 279, emojis: '🐦🌊🌧️' }, // Pelipper
  { id: 280, emojis: '👶🎀🌹' }, // Ralts
  { id: 281, emojis: '👸🎀🌹' }, // Kirlia
  { id: 282, emojis: '👸🎀🌹' }, // Gardevoir
  { id: 283, emojis: '🕷️🌸💧' }, // Surskit
  { id: 284, emojis: '🦋🌼💧' }, // Masquerain
  { id: 285, emojis: '🍄🌱🌳' }, // Shroomish
  { id: 286, emojis: '🍄💪🦘' }, // Breloom
  { id: 287, emojis: '🦥😴🌳' }, // Slakoth
  { id: 288, emojis: '🦥🏃💨' }, // Vigoroth
  { id: 289, emojis: '🦥🛌😴' }, // Slaking
  { id: 290, emojis: '🐛🐜🕳️' }, // Nincada
  { id: 291, emojis: '🦟💨🦋' }, // Ninjask
  { id: 292, emojis: '👻🦟🛡️' }, // Shedinja
  { id: 293, emojis: '😖🔊🎶' }, // Whismur
  { id: 294, emojis: '🎵🎶🔊' }, // Loudred
  { id: 295, emojis: '🔊😠🎶' }, // Exploud
  { id: 296, emojis: '💪👊😄' }, // Makuhita
  { id: 297, emojis: '🤚💪😠' }, // Hariyama
  { id: 298, emojis: '🔵😟💧' }, // Azurill
  { id: 299, emojis: '🗿👃⛰️' }, // Nosepass
  { id: 300, emojis: '🐱🎀🌸' }, // Skitty
  { id: 301, emojis: '🐱🎀💃' }, // Delcatty
  { id: 302, emojis: '👻💎👀' }, // Sableye
  { id: 303, emojis: '👹🦷🌸' }, // Mawile
  { id: 304, emojis: '🛡️👶⛰️' }, // Aron
  { id: 305, emojis: '⛰️🛡️🦖' }, // Lairon
  { id: 306, emojis: '🛡️🦖🗻' }, // Aggron
  { id: 307, emojis: '🧘‍♀️💪👁️' }, // Meditite
  { id: 308, emojis: '🧘‍♀️💪👁️' }, // Medicham
  { id: 309, emojis: '🐕⚡💨' }, // Electrike
  { id: 310, emojis: '⚡🐕🌩️' }, // Manectric
  { id: 311, emojis: '➕⚡👶' }, // Plusle
  { id: 312, emojis: '➖⚡👶' }, // Minun
  { id: 313, emojis: '🐞🌟🔦' }, // Volbeat
  { id: 314, emojis: '🦋💡💃' }, // Illumise
  { id: 315, emojis: '🌹🌸☢️' }, // Roselia
  { id: 316, emojis: '🐌☢️🍔' }, // Gulpin
  { id: 317, emojis: '🐌☢️🍔' }, // Swalot
  { id: 318, emojis: '🦈💦🔪' }, // Carvanha
  { id: 319, emojis: '🦈💦🔪' }, // Sharpedo
  { id: 320, emojis: '🐋💦🌊' }, // Wailmer
  { id: 321, emojis: '🐋💦🌊' }, // Wailord
  { id: 322, emojis: '🐫🔥🌵' }, // Numel
  { id: 323, emojis: '🐫🔥🌵' }, // Camerupt
  { id: 324, emojis: '🐢🔥🌴' }, // Torkoal
  { id: 325, emojis: '🐷💓🐽' }, // Spoink
  { id: 326, emojis: '🐖⚫🐽' }, // Grumpig
  { id: 327, emojis: '😵💃🎶' }, // Spinda
  { id: 328, emojis: '🕳️🦗🏜️' }, // Trapinch
  { id: 329, emojis: '🦗🏜️🌪️' }, // Vibrava
  { id: 330, emojis: '🐉🏜️🌪️' }, // Flygon
  { id: 331, emojis: '🌵👑🟢' }, // Cacnea
  { id: 332, emojis: '🌵👥🌑' }, // Cacturne
  { id: 333, emojis: '🐑🌤️🔵' }, // Swablu
  { id: 334, emojis: '🐑🌤️🌈' }, // Altaria
  { id: 335, emojis: '🐈⚔️🔪' }, // Zangoose
  { id: 336, emojis: '🐍⚔️☣️' }, // Seviper
  { id: 337, emojis: '🌙🪐💫' }, // Lunatone
  { id: 338, emojis: '☀️🪐💫' }, // Solrock
  { id: 339, emojis: '🐟💦🏞️' }, // Barboach
  { id: 340, emojis: '🐟🌊🏞️' }, // Whiscash
  { id: 341, emojis: '🦀🔪💦' }, // Corphish
  { id: 342, emojis: '🦀🔪⭐' }, // Crawdaunt
  { id: 343, emojis: '🏜️🧠🔮' }, // Baltoy
  { id: 344, emojis: '🏜️🧠👁️' }, // Claydol
  { id: 345, emojis: '🌷🐚🌺' }, // Lileep
  { id: 346, emojis: '🌷🏞️🦑' }, // Cradily
  { id: 347, emojis: '🦀🕷️🦴' }, // Anorith
  { id: 348, emojis: '🦀🕷️⚔️' }, // Armaldo
  { id: 349, emojis: '🐟👄💧' }, // Feebas
  { id: 350, emojis: '🐟🧜‍♀️💧' }, // Milotic
  { id: 351, emojis: '☁️🌤️🌧️' }, // Castform
  { id: 352, emojis: '🦎🌈🔄' }, // Kecleon
  { id: 353, emojis: '👻🎭🎪' }, // Shuppet
  { id: 354, emojis: '👻🎭⚔️' }, // Banette
  { id: 355, emojis: '👻👁️🌑' }, // Duskull
  { id: 356, emojis: '👻👁️⏳' }, // Dusclops
  { id: 357, emojis: '🌴🍌🦜' }, // Tropius
  { id: 358, emojis: '🔔🎵🌈' }, // Chimecho
  { id: 359, emojis: '🐺⚔️🌑' }, // Absol
  { id: 360, emojis: '👶🎀🤔' }, // Wynaut
  { id: 361, emojis: '❄️⛄👶' }, // Snorunt
  { id: 362, emojis: '⚪❄️🌨️' }, // Glalie
  { id: 363, emojis: '🔵👏❄️' }, // Spheal
  { id: 364, emojis: '🐋🧊🌊' }, // Sealeo
  { id: 365, emojis: '🐋🧊🌊' }, // Walrein
  { id: 366, emojis: '🦪🌊🐚' }, // Clamperl
  { id: 367, emojis: '🐟🦷🌊' }, // Huntail
  { id: 368, emojis: '🐠👄🌊' }, // Gorebyss
  { id: 369, emojis: '🐟🗿🌊' }, // Relicanth
  { id: 370, emojis: '💗🐟💦' }, // Luvdisc
  { id: 371, emojis: '🐲👶😖' }, // Bagon
  { id: 372, emojis: '🛡️🥚🐲' }, // Shelgon
  { id: 373, emojis: '🐉🐲☁️' }, // Salamence
  { id: 374, emojis: '🔩🧠🔮' }, // Beldum
  { id: 375, emojis: '🔩🧠🔮' }, // Metang
  { id: 376, emojis: '🔩🧠💪' }, // Metagross
  { id: 377, emojis: '⛰️⚔️🗿' }, // Regirock
  { id: 378, emojis: '❄️⚔️🗿' }, // Regice
  { id: 379, emojis: '🛡️⚔️🗿' }, // Registeel
  { id: 380, emojis: '🐉✨💫' }, // Latias
  { id: 381, emojis: '🐉✨💫' }, // Latios
  { id: 382, emojis: '🐋🌊🌀' }, // Kyogre
  { id: 383, emojis: '🦖🌋🔥' }, // Groudon
  { id: 384, emojis: '🐉🐍🌌' }, // Rayquaza
  { id: 385, emojis: '🌠💫✨' }, // Jirachi
  { id: 386, emojis: '👽⚔️🪐' }, // Deoxys
  { id: 387, emojis: '🐢🌿🍃' }, // Turtwig
  { id: 388, emojis: '🐢🌿🌳' }, // Grotle
  { id: 389, emojis: '🐢🗻🏕️' }, // Torterra
  { id: 390, emojis: '🐵🔥👶' }, // Chimchar
  { id: 391, emojis: '🐵🔥👊' }, // Monferno
  { id: 392, emojis: '🐵🔥👊' }, // Infernape
  { id: 393, emojis: '🐧👶🌊' }, // Piplup
  { id: 394, emojis: '🐧💦🌊' }, // Prinplup
  { id: 395, emojis: '🐧🌊🔱' }, // Empoleon
  { id: 396, emojis: '🐤🌑🐥' }, // Starly
  { id: 397, emojis: '🐦🖤🌑' }, // Staravia
  { id: 398, emojis: '🦅🖤🌑' }, // Staraptor
  { id: 399, emojis: '🌰🌳🌾' }, // Bidoof
  { id: 400, emojis: '🌰🌳🌊' }, // Bibarel
  { id: 401, emojis: '🦗🎶🌿' }, // Kricketot
  { id: 402, emojis: '🦗🎵🌿' }, // Kricketune
  { id: 403, emojis: '🐈⚡👶' }, // Shinx
  { id: 404, emojis: '🐈⚡🌩️' }, // Luxio
  { id: 405, emojis: '🦁⚡🌩️' }, // Luxray
  { id: 406, emojis: '🌱☢️👶' }, // Budew
  { id: 407, emojis: '🌸💃☢️' }, // Roserade
  { id: 408, emojis: '💀💥🦕' }, // Cranidos
  { id: 409, emojis: '💀💥🦕' }, // Rampardos
  { id: 410, emojis: '🛡️🦏🌳' }, // Shieldon
  { id: 411, emojis: '🛡️🦏⛰️' }, // Bastiodon
  { id: 412, emojis: '🐛👪🌺' }, // Burmy
  { id: 413, emojis: '🐛👪🌺' }, // Wormadam
  { id: 414, emojis: '🦋🏵️🌻' }, // Mothim
  { id: 415, emojis: '🐝🍯🌸' }, // Combee
  { id: 416, emojis: '🐝👑🌸' }, // Vespiquen
  { id: 417, emojis: '⚡🐿️🌰' }, // Pachirisu
  { id: 418, emojis: '🦦💦🌊' }, // Buizel
  { id: 419, emojis: '🦦🌊💨' }, // Floatzel
  { id: 420, emojis: '🍒🌸🌿' }, // Cherubi
  { id: 421, emojis: '🍒🌸🌞' }, // Cherrim
  { id: 422, emojis: '🐌👨‍👧🌊' }, // Shellos
  { id: 423, emojis: '🐌🌊👨‍👧' }, // Gastrodon
  { id: 424, emojis: '🐵🍌👋' }, // Ambipom
  { id: 425, emojis: '🎈👻💨' }, // Drifloon
  { id: 426, emojis: '🎈👻✈️' }, // Drifblim
  { id: 427, emojis: '🐇🎀🌸' }, // Buneary
  { id: 428, emojis: '🐇💃🌸' }, // Lopunny
  { id: 429, emojis: '👻🎩🔮' }, // Mismagius
  { id: 430, emojis: '🦅🎩🌙' }, // Honchkrow
  { id: 431, emojis: '😺💅💄' }, // Glameow
  { id: 432, emojis: '😺💅👑' }, // Purugly
  { id: 433, emojis: '🔔🎶🟡' }, // Chingling
  { id: 434, emojis: '🦨💨☢️' }, // Stunky
  { id: 435, emojis: '🦨💨☢️' }, // Skuntank
  { id: 436, emojis: '⚙️🟡🔵' }, // Bronzor
  { id: 437, emojis: '🔔⚙️🧠' }, // Bronzong
  { id: 438, emojis: '🌳👶🙅‍♂️' }, // Bonsly
  { id: 439, emojis: '🎭🎩👶' }, // Mime Jr.
  { id: 440, emojis: '👼🌸🥚' }, // Happiny
  { id: 441, emojis: '🐦🎵🎶' }, // Chatot
  { id: 442, emojis: '👻🔮⚫' }, // Spiritomb
  { id: 443, emojis: '🦈🌪️🌵' }, // Gible
  { id: 444, emojis: '🦈🌪️🌵' }, // Gabite
  { id: 445, emojis: '🦈🐉🌪️' }, // Garchomp
  { id: 446, emojis: '🍽️😴🛏️' }, // Munchlax
  { id: 447, emojis: '🥊🐶👶' }, // Riolu
  { id: 448, emojis: '🥊🐶💪' }, // Lucario
  { id: 449, emojis: '🦛🌵🕳️' }, // Hippopotas
  { id: 450, emojis: '🦛🌵🕳️' }, // Hippowdon
  { id: 451, emojis: '🦂🌵⚠️' }, // Skorupi
  { id: 452, emojis: '🦂🌑☢️' }, // Drapion
  { id: 453, emojis: '🐸💢👊' }, // Croagunk
  { id: 454, emojis: '🐸👊☢️' }, // Toxicroak
  { id: 455, emojis: '🌿👹🍽️' }, // Carnivine
  { id: 456, emojis: '🐠💅💦' }, // Finneon
  { id: 457, emojis: '🐠🦋💅' }, // Lumineon
  { id: 458, emojis: '🐟😄🌊' }, // Mantyke
  { id: 459, emojis: '⛄🌲❄️' }, // Snover
  { id: 460, emojis: '🌲❄️👑' }, // Abomasnow
  { id: 461, emojis: '❄️🔪️⚔️' }, // Weavile
  { id: 462, emojis: '⚡🛸⚙️' }, // Magnezone
  { id: 463, emojis: '👅🍭😛' }, // Lickilicky
  { id: 464, emojis: '🦏⛰️💥' }, // Rhyperior
  { id: 465, emojis: '🍝🌿🛡️' }, // Tangrowth
  { id: 466, emojis: '⚡👊🔌' }, // Electivire
  { id: 467, emojis: '🔥👊🌋' }, // Magmortar
  { id: 468, emojis: '🐦✨🥚' }, // Togekiss
  { id: 469, emojis: '🦟✈️👀' }, // Yanmega
  { id: 470, emojis: '🌿🐈🐾' }, // Leafeon
  { id: 471, emojis: '❄️🐈🐾' }, // Glaceon
  { id: 472, emojis: '🦇🦂✈️' }, // Gliscor
  { id: 473, emojis: '❄️🐖⛰️' }, // Mamoswine
  { id: 474, emojis: '💾🤖🧠' }, // Porygon-Z
  { id: 475, emojis: '🤺👊🌹' }, // Gallade
  { id: 476, emojis: '👃⛰️🗿' }, // Probopass
  { id: 477, emojis: '👻🌑👊' }, // Dusknoir
  { id: 478, emojis: '❄️👻🌺' }, // Froslass
  { id: 479, emojis: '📺⚡🔌' }, // Rotom
  { id: 480, emojis: '👁️🧠💛' }, // Uxie
  { id: 481, emojis: '👁️🧠💗' }, // Mesprit
  { id: 482, emojis: '👁️🧠💙' }, // Azelf
  { id: 483, emojis: '🐉⌛🌌' }, // Dialga
  { id: 484, emojis: '🐉🌊🌌' }, // Palkia
  { id: 485, emojis: '🦎🌋🔥' }, // Heatran
  { id: 486, emojis: '🗿🏔️👪' }, // Regigigas
  { id: 487, emojis: '🐲👻🌀' }, // Giratina
  { id: 488, emojis: '🌙✨🌸' }, // Cresselia
  { id: 489, emojis: '🛡️🌊👥' }, // Phione
  { id: 490, emojis: '🛡️🌊👥' }, // Manaphy
  { id: 491, emojis: '🌑👻🌙' }, // Darkrai
  { id: 492, emojis: '🌸🍃✨' }, // Shaymin
  { id: 493, emojis: '🌌🌈⬜' }, // Arceus
];
